module.exports = __webpack_public_path__ + "static/img/5.671f12c8.png";